import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight, ArrowDown } from 'lucide-react';
import { usePage } from '../contexts/PageContext';
import SEO from '../components/SEO';
import RichText from '../components/RichText';

export default function AboutPage() {
  const { t, seo } = usePage('about');
  const values = [
    { n: '01', title: t('value_1_title', 'Technology with purpose'), desc: t('value_1_desc', '') },
    { n: '02', title: t('value_2_title', 'Security as a feature'), desc: t('value_2_desc', '') },
    { n: '03', title: t('value_3_title', 'Human first'), desc: t('value_3_desc', '') },
    { n: '04', title: t('value_4_title', 'Outcome obsessed'), desc: t('value_4_desc', '') },
  ];
  return (
    <>
      <SEO title={seo.title} description={seo.description} keywords={seo.keywords} image={seo.og_image} />
      <section className="pt-24 pb-16 lg:pt-36 lg:pb-24">
        <div className="container-x">
          <span className="eyebrow">{t('hero_eyebrow', 'About us')}</span>
          <h1 className="heading-display mt-8 text-[44px] sm:text-[64px] lg:text-[96px] max-w-5xl">{t('hero_title', 'We are the AI partner financial institutions hire to go digital')}</h1>
        </div>
      </section>
      <section className="pb-20">
        <div className="container-x grid grid-cols-1 lg:grid-cols-12 gap-12 items-end">
          <div className="lg:col-span-7">
            <div className="aspect-[16/10] overflow-hidden bg-[#2A2A2A]">
              <img src="/images/hero-banner-1.webp" alt="" className="w-full h-full object-cover grayscale-[30%]" loading="lazy" />
            </div>
          </div>
          <div className="lg:col-span-5">
            <p className="text-[16px] leading-relaxed text-[#C6C4CF]"><RichText text={t('hero_description', '')} /></p>
          </div>
        </div>
      </section>
      <section className="py-24 border-t border-[#3A332A]">
        <div className="container-x grid grid-cols-1 lg:grid-cols-2 gap-16">
          <div>
            <span className="eyebrow">{t('mission_title', 'Our mission')}</span>
            <p className="mt-8 heading-display text-[28px] lg:text-[36px] heading-light"><RichText text={t('mission_text', '')} /></p>
          </div>
          <div>
            <span className="eyebrow">{t('vision_title', 'Our vision')}</span>
            <p className="mt-8 heading-display text-[28px] lg:text-[36px] heading-light"><RichText text={t('vision_text', '')} /></p>
          </div>
        </div>
      </section>
      <section className="py-24 border-t border-[#3A332A]">
        <div className="container-x">
          <span className="eyebrow">{t('values_title', 'What we believe')}</span>
          <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-12 lg:gap-16">
            {values.map((v, i) => (
              <div key={i} className="border-t border-[#3A332A] pt-8">
                <p className="text-[#F5F137] text-sm tracking-[0.28em] font-medium">{v.n}</p>
                <h3 className="heading-display text-3xl lg:text-4xl mt-4">{v.title}</h3>
                <p className="mt-4 text-[#C6C4CF] leading-relaxed"><RichText text={v.desc} /></p>
              </div>
            ))}
          </div>
        </div>
      </section>
      <section className="py-24 lg:py-32 border-t border-[#3A332A]">
        <div className="container-x grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-6">
            <h2 className="heading-display text-[36px] lg:text-[56px]">{t('team_title', 'Built by operators, marketers & engineers')}</h2>
            <p className="mt-6 text-[#C6C4CF] text-[16px] leading-relaxed"><RichText text={t('team_desc', '')} /></p>
            <Link to="/contact" className="btn-outline mt-10"><span>Talk to us</span><span className="arrow"><ArrowUpRight size={14} /></span></Link>
          </div>
          <div className="lg:col-span-6">
            <div className="aspect-[4/3] overflow-hidden bg-[#2A2A2A]">
              <img src="/images/about-2.webp" alt="" className="w-full h-full object-cover grayscale-[30%]" loading="lazy" />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
